import config from "config/index";

export function getDocumentTitle(viewTitle: string) {
    return `${viewTitle} | ${config.appBrand.charAt(0).toUpperCase()}${config.appBrand.slice(1).toLowerCase()}`;
}
